import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const Function = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();
  const [inputData, setInputData] = useState([]);
  const [primaryFuncton, setPrimaryFunction] = useState([]);
  const [secondaryFunction, setSecondaryFunction] = useState([]);

  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    if (
      eventName === "primary_function" ||
      eventName === "secondary_function"
    ) {
      if (eventName === "primary_function") {
        setPrimaryFunction(event);
      } else {
        setSecondaryFunction(event);
      }
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
        props.parentCallback(event["id"], eventName);
      } else {
        setInputData((prevState) => ({ ...prevState, [eventName]: null }));
        props.parentCallback(null, eventName);
      }
    } else {
      setInputData((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateFunction = {
      userId: inputData.userId,
      primary_function: inputData.primary_function,
      primary_function_experience: inputData.primary_function_experience,
      secondary_function: inputData.secondary_function,
      secondary_function_experience: inputData.secondary_function_experience,
    };
    dispatch(updateProfleAction(inputData.userId, updateFunction));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length >= 0) {
      const sector = {
        userId: props.profile.userId,
        primary_function: props.profile.primary_function,
        primary_function_experience: props.profile.primary_function_experience,
        secondary_function: props.profile.secondary_function,
        secondary_function_experience:
          props.profile.secondary_function_experience,
      };
      setInputData(sector);
    }

    if (props.functions) {
      if (inputData.primary_function != null) {
        const primaryFunctionData = props.functions.find(
          (row) => row.id === inputData.primary_function
        );
        if (props.primarySectorId != null) {
          setPrimaryFunction(primaryFunctionData);
        } else {
          setPrimaryFunction(null);
        }
      }
      if (inputData.secondary_function != null) {
        const secondaryFunctionData = props.functions.find(
          (row) => row.id === inputData.secondary_function
        );
        if (props.secondarySectorId != null) {
          setSecondaryFunction(secondaryFunctionData);
        } else {
          setSecondaryFunction(null);
        }
      }
    }
  }, [
    props.profile,
    props.profileData,
    props.primarySectorId,
    props.secondarySectorId,
  ]);

  return (
    <div className="row ">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Function"}
      />
      <div className="row-icon">
        <img src="/assets/images/profile-page/Function_outline.svg" alt="" />
        <img
          className="completed"
          src="/assets/images/profile-page/Recent_career_summary_active.svg"
          alt=""
        />
      </div>
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Function</h5>
          <div className="row">
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Primary Functional Experience
              </label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="primary_function"
                    name="primary_function"
                    value={
                      props.functions &&
                      props.functions.find(
                        (row) => row.id === inputData.primary_function
                      )
                    }
                    options={props.functions}
                    getOptionLabel={(option) => option.function}
                    getOptionValue={(option) => option.id}
                    onChange={(event) =>
                      handleChange(event, "primary_function")
                    }
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={props.primarySectorId === null ? true : false}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">Years Of Experience</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="number"
                    className="form-control"
                    name="primary_function_experience"
                    min="0"
                    placeholder="Primary Functional Years Of Experience"
                    onChange={(event) => handleChange(event)}
                    defaultValue={inputData.primary_function_experience}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <label className="field-label">
                Secondary Functional Experience
              </label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="secondary_function"
                    name="secondary_function"
                    value={
                      props.functions &&
                      props.functions.find(
                        (row) => row.id === inputData.secondary_function
                      )
                    }
                    options={props.functions}
                    getOptionLabel={(option) => option.function}
                    getOptionValue={(option) => option.id}
                    onChange={(event) =>
                      handleChange(event, "secondary_function")
                    }
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={
                      primaryFuncton === null ||
                      props.secondarySectorId === null
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <label className="field-label">Years Of Experience</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="number"
                    className="form-control"
                    name="secondary_function_experience"
                    min="0"
                    placeholder="Secondary Functional Years Of Experience"
                    onChange={(event) => handleChange(event)}
                    defaultValue={
                      inputData.secondary_function != null
                        ? inputData.secondary_function_experience
                        : null
                    }
                  />
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const functions = state.admin.functions;

  return {
    user: user,
    profile: profile,
    functions: functions,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Function);
